import { styled } from "@mui/material/styles";

const Root = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "50px",
  [theme.breakpoints.down("md")]: {
    padding: "20px",
  },
}));
const Tittle = styled("p")(({ theme }) => ({
  color: "#FF0000",
  fontWeight: "bold",
  fontSize: "3rem",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

export { Root, Tittle };
